import { SessionSelectors } from '@next/core-lib/session';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ReportManureSubstancesView, ReportSortOption } from '../reports/models';

import { AppState, ArableSessionState } from '../shared/models';

export const selectApp = createFeatureSelector<AppState>('app');

export const selectArableSession = createSelector(
  SessionSelectors.selectSessionState,
  (session: ArableSessionState) => session?.arable,
);

export const selectUserSession = createFeatureSelector<{ user?: { customerId?: number } }>(
  'session',
);

export const selectSessionCustomerId = createSelector(
  selectUserSession,
  (session) => session?.user?.customerId,
);

export const getDefaultCropYear = createSelector(
  selectApp,
  (store: AppState) => store.defaultCropYear,
);

export const selectDefaultSoilType = createSelector(
  selectApp,
  (store: AppState) => store.defaultSoilType,
);

export const getCropYear = createSelector(
  selectArableSession,
  getDefaultCropYear,
  (arable, defaultYear) => (arable?.cropYear ? arable.cropYear : defaultYear),
);

export const getPreviousCropYear = createSelector(getCropYear, (cropYear) => cropYear - 1);

export const getAvailableCropYears = createSelector(
  selectApp,
  (store: AppState) => store.availableCropYears || [],
);

export const getCrops = createSelector(selectApp, (store: AppState) => store.crops || []);

export const getCropVarietiesByCropId = createSelector(
  selectApp,
  (store: AppState, cropId: number) =>
    store.cropVarieties?.length
      ? store.cropVarieties.filter((variety) => variety.cropId === cropId)
      : [],
);

export const getSoilAnalysisByCropFieldId = createSelector(
  selectApp,
  (store: AppState, cropFieldId: number) =>
    store.soilAnalysisByCropFieldId
      ? store.soilAnalysisByCropFieldId.find((analysis) => analysis.id === cropFieldId)
      : null,
);

export const getReportSort = createSelector(
  selectApp,
  (store) => store.reportSort ?? { option: ReportSortOption.sortCropFieldName, descending: false },
);

export const getReportManureSubstancesView = createSelector(
  selectApp,
  (store) => store.reportManureSubstancesView ?? ReportManureSubstancesView.manureDetails,
);

export const selectCustomerProgress = createSelector(selectApp, (store) => store.customerProgress);
